<template>
    <div class="card">
        <DataTable :loading="isLoading" :value="withdrawals">
            <Column :headerStyle="headerStyles" field="id" header="Publisher">
                <template #body="{data}">
                    <router-link :to="`/users/${data.walletId.userId._id}`" class="clickable-link">
                        {{ data.walletId.userId.type === 'Company' ? data.walletId.userId.companyName : data.walletId.userId.name }}
                    </router-link>
                </template>
            </Column>
            <Column :headerStyle="headerStyles" field="amount" header="Amount">
                <template #body="slotProps">
                    <p>{{ formatCurrencyWithCents(Math.abs(slotProps.data.amount)) }}</p>
                </template>
            </Column>
            <Column :headerStyle="headerStyles" field="status" header="Status">
                <template #body="slotProps">
                    <Tag :value="capitalizeFirstLetter(slotProps.data.status)"
                        :severity="getStatusSeverity(slotProps.data.status)" />
                </template>
            </Column>
            <Column :headerStyle="headerStyles" field="createdAt" header="Created At">
                <template #body="slotProps">
                    <p>{{ formatDateTime(slotProps.data.createdAt) }}</p>
                </template>
            </Column>
        </DataTable>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import WalletService from '@/services/WalletService';
import { headerStyles } from '@/global/headerStyles';
import { formatCurrencyWithCents } from '@/utils/currencies';
import Tag from 'primevue/tag';
import { getStatusSeverity } from '@/utils/wallet-helper';
import { capitalizeFirstLetter } from '@/utils/string';
import { formatDateTime } from '@/utils/dateHelper';

const withdrawals = ref([]);
const isLoading = ref(true);
onMounted(async () => {
    try {
        isLoading.value = true;
        const response = await WalletService.getAllWithdrawals();
        withdrawals.value = response.data;
    }
    catch (error) {
        console.log(error);
    }
    finally {
        isLoading.value = false;
    }
});
</script>

<style scoped>
.clickable-link {
    text-decoration: underline;
    color: inherit;
    /* Inherit color from the parent element */
    cursor: pointer;
}
</style>